import React from "react";

import "./EndoresementItem.scss";

const EndoresementItem = ({
  name,
  content,
  profilePic,
  mentorUrl,
}: {
  name: string;
  content: string;
  profilePic: string;
  mentorUrl: string;
}) => {
  return (
    <div className="card">
      <div className="user-photo">
        <img src={profilePic} alt={name} />
      </div>
      <div className="name">
        <a href={mentorUrl}>{name}</a>
      </div>
      <div className="content">
        {content}...{" "}
        <a href="https://www.linkedin.com/in/shah-swapnil/details/recommendations">
          <span>See More</span>
        </a>
      </div>
      <div className="source">
        Source:{" "}
        <a href="https://www.linkedin.com/in/shah-swapnil/details/recommendations">
          Linkedin
        </a>{" "}
      </div>
    </div>
  );
};

export default EndoresementItem;
